<script lang="ts" setup>
import nameLogo from '~/assets/icons/logo/name.svg?url';
import image from '~/assets/images/subscription_product_banner_background.jpg';
import image_mobile from '~/assets/images/subscription_product_banner_mobile_background.jpg';

const { t } = useI18n();

useSeoMeta({
  title: t('meta.title'),
  description: t('meta.description'),
  ogTitle: t('meta.title'),
  ogDescription: t('meta.description'),
});
</script>

<template>
  <section class="subscriptionProductBanner">
    <picture>
      <source :srcset="image_mobile" media="(max-width: 767px)" />
      <img :src="image" :alt="t('description')" class="subscriptionProductBanner__image" />
    </picture>

    <div class="subscriptionProductBanner__info">
      <h2 class="subscriptionProductBanner__title">
        {{ t('title') }}
      </h2>
      <p class="subscriptionProductBanner__description">
        {{ t('description') }}
      </p>
      <BaseButton to="/catalog" class="subscriptionProductBanner__action">
        {{ t('action') }}
      </BaseButton>
    </div>
    <NuxtLink to="/">
      <img :src="nameLogo" alt="Don't Touch My Skin" class="subscriptionProductBanner__logo" />
    </NuxtLink>
  </section>
</template>

<i18n>
ru:
  title: Привычный уход со скидкой 30%
  description: Подписка на регулярную доставку рефилов
  action: Выбрать средство
  meta:
    title: 'Подписка на рефилы DTMS со скидкой 30%: регулярная доставка без автоплатежей'
    description: Оформите подписку на рефилы DTMS и получайте любимые средства со скидкой 30% каждые 3 месяца. Удобно, выгодно и экологично. Отмена в любой момент.

en:
  title: Familiar Skincare Routine with a 30% Discount
  description: Subscription for regular refill delivery
  action: Select Product
  meta:
    title: 'DTMS Refill Subscription with 30% Discount: Regular Delivery without Autopay'
    description: Subscribe to DTMS refills and get your favorite products with a 30% discount every 3 months. Convenient, profitable, and eco-friendly. Cancel anytime.
</i18n>

<style lang="scss">
.subscriptionProductBanner {
  $self: &;

  height: 100svh;
  position: relative;
  overflow: hidden;
  background-color: #121212;

  &__logo {
    position: absolute;
    top: 30px;
    left: 21px;

    @include mq('sm') {
      width: 121px;
      height: 126px;
    }
  }

  &__image {
    position: absolute;
    height: 100%;
    width: 100%;
    object-fit: cover;
    display: block;
  }

  &__info {
    position: absolute;
    left: 150px;
    bottom: 51px;

    @include mq('sm') {
      left: 50px;
    }
  }

  &__title {
    font-size: 56px;
    letter-spacing: 0.2px;
    color: #ffffff;
    margin-top: 0;
    margin-bottom: 27px;
    max-width: 421px;

    @include mq('sm') {
      font-size: 24px;
      line-height: 32px;
      max-width: 50%;
    }
  }

  &__description {
    font-size: 28px;
    letter-spacing: 0.2px;
    color: #ffffff;
    margin: 0;
    max-width: 416px;
    margin-bottom: 27px;

    @include mq('sm') {
      font-size: 18px;
      line-height: 18px;
      max-width: 60%;
    }
  }

  &__action {
    background-color: #e68699;
    width: 100%;
    color: #ffffff;

    @include mq('sm') {
      font-size: 16px;
      line-height: 24px;
      max-width: 60%;
    }
  }
}
</style>
